import { Airport } from 'acscp/api/models/airport';

export const getDisplayTextForAirport = (airport: Airport | null) => {
    if (!airport) {
        return '';
    }
    return !airport.iataCode ?
        airport.name :
        `${airport.name} (${airport.iataCode})`;
};
